<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">receipt_long</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Transacciones CBPay</h1>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de Búsqueda
      </h2>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Documento de identidad</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">badge</mat-icon>
          <input matInput [(ngModel)]="idNumberDestination" placeholder="V1111111">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Desde</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">calendar_today</mat-icon>
          <input matInput [matDatepicker]="fromPicker" [(ngModel)]="from">
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Hasta</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">event</mat-icon>
          <input matInput [matDatepicker]="toPicker" [(ngModel)]="to">
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
        <button type="button" (click)="loadTransactions()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>
        <button type="button" (click)="reload()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">refresh</mat-icon>
          Refrescar
        </button>
        <button type="button" (click)="exportarExcel()"
          [disabled]="!transactions || transactions.length === 0"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          [style.opacity]="!transactions || transactions.length === 0 ? '0.5' : '1'"
          [style.cursor]="!transactions || transactions.length === 0 ? 'not-allowed' : 'pointer'"
          onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #166534;">download</mat-icon>
          Exportar Excel
        </button>
      </div>
    </div>
  </div>

  <!-- Card Tabla Transacciones -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Listado de Transacciones
      </h2>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full" *ngIf="dataSource">

        <ng-container matColumnDef="transaction_id">
          <th mat-header-cell *matHeaderCellDef style="min-width: 160px;">Transaction ID</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.transactionId }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef style="min-width: 150px;">Tipo</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getTransactionType(row.tipo) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="idUsuario">
          <th mat-header-cell *matHeaderCellDef style="min-width: 110px;">ID Usuario</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row?.data?.infoUsuario?.userId }}</span></td>
        </ng-container>

        <ng-container matColumnDef="transactionStatus">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Estado Transaccion</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row?.transaccion?.estado || 'Sin estado' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="beneficiario">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Beneficiario</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row?.data?.infoUsuario?.name || 'No disponible' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="monto">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Monto</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row?.data?.infoUsuario?.amount || 0 }}</span></td>
        </ng-container>

        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef style="min-width: 130px;">Documento</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row?.data?.infoUsuario?.idNumberDestino || 'Sin documento' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Fecha</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.fecha | date:'dd/MM/yyyy HH:mm' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Estado CBPay</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="row.status ? '#dcfce7' : '#fef2f2'"
              [style.color]="row.status ? '#166534' : '#dc2626'">
              {{ row.status ? 'Realizada' : 'No enviada' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="mensaje">
          <th mat-header-cell *matHeaderCellDef style="min-width: 160px;">Mensaje</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.mensaje }}</span></td>
        </ng-container>

        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef style="min-width: 90px; text-align: center;">Data</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <button type="button" (click)="showData(row.data)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #e9d5ff; border-radius: 6px; background: #faf5ff; cursor: pointer;"
              onmouseover="this.style.background='#f3e8ff'" onmouseout="this.style.background='#faf5ff'"
              title="Ver Data">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #7c3aed;">visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <div class="flex items-center justify-center gap-1"
              *ngIf="!row.status && row.transaccion?.estado !== 'RECHAZADA' && row.transaccion?.estado !== 'ENVIADA'">
              <button type="button" title="Reintentar" (click)="confirmAssignTransaction(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fcd34d; border-radius: 6px; background: #fef3c7; cursor: pointer;"
                onmouseover="this.style.background='#fde68a'" onmouseout="this.style.background='#fef3c7'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #92400e;">replay</mat-icon>
              </button>
              <button type="button" title="Reasignar" (click)="openAssignDialog(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">swap_horiz</mat-icon>
              </button>
              <button type="button" title="Rechazar" (click)="openRejectTransactionModal(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">block</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center text-gray-400 py-8" [attr.colspan]="displayedColumns.length">
            No se encontraron transacciones
          </td>
        </tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let row of dataSource.data; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full shrink-0"
              [style.background]="row.status ? '#dcfce7' : '#fef2f2'"
              [style.color]="row.status ? '#166534' : '#dc2626'">
              {{ row.status ? 'Realizada' : 'No enviada' }}
            </span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ row.transactionId }}</span>
          </div>
          <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getTransactionType(row.tipo) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">ID Usuario</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row?.data?.infoUsuario?.userId }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Estado Transaccion</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row?.transaccion?.estado || 'Sin estado' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Beneficiario</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row?.data?.infoUsuario?.name || 'No disponible' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Monto</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row?.data?.infoUsuario?.amount || 0 }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Documento</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row?.data?.infoUsuario?.idNumberDestino || 'Sin documento' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.fecha | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Mensaje</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.mensaje }}</p>
            </div>
          </div>

          <!-- Card Footer Actions -->
          <div class="flex flex-wrap gap-2 mt-3 pt-3 border-t border-gray-100">
            <button type="button" (click)="showData(row.data)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #e9d5ff; border-radius: 8px; background: #faf5ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #7c3aed;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #7c3aed;">visibility</mat-icon>
              Ver Data
            </button>
            <button type="button" *ngIf="!row.status && row.transaccion?.estado !== 'RECHAZADA' && row.transaccion?.estado !== 'ENVIADA'"
              (click)="confirmAssignTransaction(row)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fcd34d; border-radius: 8px; background: #fef3c7; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #92400e;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #92400e;">replay</mat-icon>
              Reintentar
            </button>
            <button type="button" *ngIf="!row.status && row.transaccion?.estado !== 'RECHAZADA' && row.transaccion?.estado !== 'ENVIADA'"
              (click)="openAssignDialog(row)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">swap_horiz</mat-icon>
              Reasignar
            </button>
            <button type="button" *ngIf="!row.status && row.transaccion?.estado !== 'RECHAZADA' && row.transaccion?.estado !== 'ENVIADA'"
              (click)="openRejectTransactionModal(row)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">block</mat-icon>
              Rechazar
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="dataSource.data.length === 0" class="text-center text-gray-400 py-8">
        No se encontraron transacciones
      </div>
    </div>

    <!-- Paginacion -->
    <div class="p-4">
      <mat-paginator #paginator
        [length]="total"
        [pageSize]="limit"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageIndex]="page - 1"
        aria-label="Select page"
        (page)="changePage($event)">
      </mat-paginator>
    </div>
  </div>
</div>
